<template>
    <ResourceCard
        v-if="collection.data"
        class="collection-card"
        document-type="collection"
        :title="collection.data.title"
        :excerpt="collection.data.excerpt"
        :to="resolvePrismicLink(collection)"
        :base-data-testid="baseDataTestid"
        :resource-categories="(collection.data?.resourceCategories as {resourceCategory: ResourceCategoryDocument}[]) ?? undefined"
        :category="collection.data?.category"
    >
        <template #image-overlay>
            <CollectionThumbnail :collection="collection" />
        </template>
    </ResourceCard>
</template>

<script lang="ts" setup>
    import {ref} from 'vue';
    import type {FilledContentRelationshipField} from '@prismicio/client';
    import type {CollectionDocument, CollectionDocumentData, ResourceCategoryDocument} from '@prismicio-types';
    import {useLinkHelper} from '#imports';
    import CollectionThumbnail from '~/components/CollectionThumbnail.vue';
    import ResourceCard from '~/components/ResourceCard.vue';

    const {resolvePrismicLink} = useLinkHelper();
    const props = defineProps<{
        collection: CollectionDocument | FilledContentRelationshipField<'collection', string, CollectionDocumentData>;
    }>();

    const baseDataTestid = ref(props.collection.uid ?? props.collection.id);
</script>
